(function () {
  function num(x, d, t, dp) {
    var parts = x.toFixed(d).split('.');
    var intPart = parts[0], out = '';
    while (intPart.length > 3) { out = t + intPart.slice(-3) + out; intPart = intPart.slice(0, -3); }
    parts[0] = intPart + out;
    return parts.join(dp);
  }
  function money(cents, f) {
    var a = cents / 100;
    f = f || '';
    var start = f.indexOf('{{'), end = f.indexOf('}}');
    var key = 'amount', token = '';
    if (start > -1 && end > start) { token = f.slice(start, end + 2); key = f.slice(start + 2, end).trim(); }
    var out;
    switch (key) {
      case 'amount_no_decimals': out = num(a, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = num(a, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(a, 0, '.', ','); break;
      case 'amount_with_space_separator': out = num(a, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': out = num(a, 2, "'", '.'); break;
      default: out = num(a, 2, ',', '.');
    }
    return token ? f.replace(token, out) : out + ' MAD';
  }
  function setText(el, t) { if (el) el.textContent = t; }
  function setVal(el, v) { if (el) el.value = v; }

  function init(root) {
    var $ = function (s) { return root.querySelector(s); };
    var data = JSON.parse($('[data-nxp-json]').textContent);
    var fmt = function (c) { return money(c, data.moneyFormat); };
    var select = $('[data-variant-select]');
    var qtyInput = $('[data-qty]');
    var idInput = $('.nxp__product-form input[name="id"]');
    var variant = data.variants[0];
    function pick() {
      if (!select) return;
      data.variants.forEach(function (x) { if (String(x.id) === select.value) variant = x; });
    }
    pick();

    function update() {
      var q = 1;
      if (qtyInput) {
        q = Math.max(1, Math.min(10, parseInt(qtyInput.value, 10) || 1));
        qtyInput.value = q;
      }
      var total = fmt(variant.price * q);
      setText($('[data-price]'), fmt(variant.price));
      setText($('[data-sticky-price]'), fmt(variant.price));
      setText($('[data-total]'), total);
      setVal($('[data-f-total]'), total);
      setVal($('[data-f-variant]'), variant.title);
      setVal($('[data-f-variant-id]'), variant.id);
      if (idInput && String(idInput.value) !== String(variant.id)) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var c = $('[data-compare]'), s = $('[data-save]');
      if (c && s) {
        if (variant.compare > variant.price) {
          c.textContent = fmt(variant.compare); c.hidden = false;
          s.textContent = 'Économisez ' + fmt(variant.compare - variant.price); s.hidden = false;
        } else { c.hidden = true; s.hidden = true; }
      }
    }
    if (select) select.addEventListener('change', function () {
      pick(); update();
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    });
    if (qtyInput) {
      $('[data-qty-minus]').addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1; update(); });
      $('[data-qty-plus]').addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; update(); });
      qtyInput.addEventListener('change', update);
    }

    var slides = $('[data-slides]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.getAttribute('data-thumb'), 10);
        slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
      });
    });
    if (slides && thumbs.length) {
      slides.addEventListener('scroll', function () {
        var i = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach(function (b, j) { b.classList.toggle('is-active', i === j); });
      }, { passive: true });
    }

    var form = $('.nxp__form');
    if (form) {
      var btn = $('[data-submit]');
      var err = $('[data-error]');
      var label = btn.textContent;
      form.addEventListener('submit', function (e) {
        if (form.dataset.native === '1') return;
        e.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var ref = 'NX-' + Date.now().toString(36).toUpperCase().slice(-6);
        $('[data-f-ref]').value = ref;
        btn.disabled = true; btn.textContent = 'Envoi en cours…'; err.hidden = true;
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
          .then(function (r) {
            if (r.url.indexOf('contact_posted=true') > -1) {
              form.hidden = true;
              $('[data-ref-out]').textContent = ref;
              var ok = $('[data-success]');
              ok.hidden = false;
              ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              form.dataset.native = '1';
              HTMLFormElement.prototype.submit.call(form);
            }
          })
          .catch(function () {
            btn.disabled = false; btn.textContent = label;
            err.textContent = 'La connexion a échoué. Réessayez, ou commandez via WhatsApp.';
            err.hidden = false;
          });
      });
    }

    var sticky = $('[data-sticky]');
    var card = $('.nxp__form-card');
    var title = $('.nxp__title');
    if (sticky && card && 'IntersectionObserver' in window) {
      var cardVisible = false, titleVisible = true;
      var sync = function () { sticky.classList.toggle('is-hidden', cardVisible || titleVisible); };
      new IntersectionObserver(function (en) { cardVisible = en[0].isIntersecting; sync(); }).observe(card);
      new IntersectionObserver(function (en) { titleVisible = en[0].isIntersecting; sync(); }).observe(title);
    } else if (sticky) {
      sticky.classList.remove('is-hidden');
    }
  }

  function boot() { document.querySelectorAll('[data-nxp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();